export const REQUEST_FEEDBACK_LIST = "REQUEST_FEEDBACK_LIST";
export const SET_FEEDBACK_LIST = "SET_FEEDBACK_LIST";

export const REQUEST_SEND_ADMIN_FEEDBACK = "REQUEST_SEND_ADMIN_FEEDBACK";
export const ERROR_SEND_ADMIN_FEEDBACK = "ERROR_SEND_ADMIN_FEEDBACK";
export const SUCCESS_REPLY_SEND = "SUCCESS_REPLY_SEND";
